import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RegularButton } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import {
  BASKET_FLOW_LOAD,
  BASKET_FLOW_UPDATE,
  BASKET_FLOW_UPDATE_ITEM,
  BasketItem,
  useBasketUpdate,
} from 'features/basket';
import { getSet } from 'features/related-products/selectors';
import { PdpPriceView } from 'features/product-info/components/pdp-price-view';
import { YandexSplitBanner } from 'features/yandex-split-banner';
import { getYaSplitInfo } from 'features/page-model';
import { Gallery } from './gallery';
import { getSortedProducts } from './utils/get-sorted-products';
import { container, buySet } from './styles';
import { getMaxStockAvailable, getStocksInStores } from 'features/goods-supply';
import { hasStock } from 'features/product-info/utils';
import { getIsBot } from 'common/selectors';

const DATA_QA_SET_BLOCK = 'set-block';

export function SetBlock() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const set = useSelector(getSet);
  const stocks = useSelector(getStocksInStores);
  const maxStockAvailable = useSelector(getMaxStockAvailable);
  const yaSplitInfo = useSelector(getYaSplitInfo);
  const isBot = useSelector(getIsBot);

  function initBasket() {
    dispatch(BASKET_FLOW_LOAD());
  }

  function updateBasket(basketItem: BasketItem[]) {
    return dispatch(BASKET_FLOW_UPDATE(basketItem));
  }

  useBasketUpdate(initBasket, updateBasket);

  if (!set) return null;

  const eligible = hasStock(stocks) || maxStockAvailable > 0 || isBot;

  const content = getSortedProducts(set.content);

  function addToCart() {
    content.forEach(({ productId, quantity }) => {
      dispatch(BASKET_FLOW_UPDATE_ITEM({ productId: `${productId}`, flowQty: quantity }));
    });
  }

  return (
    <div className={container} data-qa={DATA_QA_SET_BLOCK}>
      <PdpPriceView isStickyPanel={false} inBasket={false} quantity={0} />
      {eligible && (
        <RegularButton
          onClick={addToCart}
          href="/basket/"
          className={buySet}
          size="l"
          variant="primary"
          wide
        >
          {t('product-info.set.buy')}
        </RegularButton>
      )}
      {yaSplitInfo && eligible && (
        <YandexSplitBanner yaSplitInfo={yaSplitInfo} price={set.price} isSet quantity={1} />
      )}
      <Gallery addToCart={addToCart} eligible={eligible} products={content} />
    </div>
  );
}
